import React from 'react';
import { FaHistory, FaSync } from 'react-icons/fa';
import { Card, SectionTitle, StatusBadge, Spinner, EmptyState } from './Primitives';
import { formatDateTime, completedFromSummary } from '../utils/format';

/**
 * Storico recente dei batch dell'utente. Sola visualizzazione; ricaricabile.
 */
export default function HistoryPanel({ items, loading, error, onReload, onOpen, activeBatchId }) {
  return (
    <Card className="p-5">
      <SectionTitle
        icon={FaHistory}
        title="Storico batch"
        subtitle="Le tue generazioni recenti"
        action={
          <button
            type="button"
            onClick={onReload}
            className="flex items-center gap-1.5 rounded-lg px-2 py-1 text-xs text-gray-500 hover:bg-gray-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary dark:text-gray-400 dark:hover:bg-gray-700"
            aria-label="Ricarica storico"
          >
            <FaSync className={loading ? 'animate-spin' : ''} size={12} />
            Ricarica
          </button>
        }
      />

      <div className="mt-4">
        {loading && items.length === 0 ? (
          <div className="flex items-center gap-2 py-6 text-sm text-gray-500 dark:text-gray-400">
            <Spinner className="h-4 w-4" /> Caricamento storico…
          </div>
        ) : error ? (
          <div className="rounded-xl bg-red-50 p-3 text-sm text-red-700 dark:bg-red-900/30 dark:text-red-300">
            {error}
          </div>
        ) : items.length === 0 ? (
          <EmptyState icon={FaHistory} title="Nessun batch" hint="Le generazioni avviate appariranno qui." />
        ) : (
          <ul className="space-y-2">
            {items.map((b) => {
              const done = completedFromSummary(b.summary);
              const total = b.summary?.total || 0;
              const active = b.batchId === activeBatchId;
              return (
                <li key={b.batchId}>
                  <button
                    type="button"
                    onClick={() => onOpen && onOpen(b.batchId)}
                    className={`flex w-full items-center gap-3 rounded-xl border px-3 py-2.5 text-left transition-all focus:outline-none focus-visible:ring-2 focus-visible:ring-primary ${
                      active
                        ? 'border-primary bg-primary/5 dark:bg-primary/10'
                        : 'border-gray-200 bg-white hover:bg-gray-50 dark:border-gray-700 dark:bg-gray-800 dark:hover:bg-gray-700/50'
                    }`}
                  >
                    <span className="min-w-0 flex-1">
                      <span className="block font-mono text-xs text-gray-500 dark:text-gray-400">
                        {b.batchId?.slice(0, 8)}…
                      </span>
                      <span className="mt-0.5 block text-xs text-gray-400">
                        {formatDateTime(b.createdAt)}
                      </span>
                    </span>
                    <span className="shrink-0 text-xs text-gray-500 dark:text-gray-400 tabular-nums">
                      {done}/{total}
                    </span>
                    <StatusBadge status={b.status} />
                  </button>
                </li>
              );
            })}
          </ul>
        )}
      </div>
    </Card>
  );
}
